// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_TestClockAdvanceRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_TestClockAdvanceRow — one recorded advance (S11 · C1).
 *
 * One row of subscription_test_clock_advances, as emitted by
 * GET /subscriptions/admin/test-clock/{subscription_id}.
 *
 * The audit is the whole point of a clock with no rollback: "quem, quando,
 * quantos dias, offset acumulado" (spec §Segurança). offset_days_after is the
 * running total AFTER this advance, so the history reads as a ladder and the
 * current offset is the newest row's value — no client-side summing, no way
 * for a client to disagree with the server about where the clock stands.
 *
 * created_at leaves as ISO-8601 UTC like every datetime on this wire; it is
 * stored GMT-3.
 */
import type { Subscriptions_TestClockChronologyRow } from './Subscriptions_TestClockChronologyRow'
import { registerContract } from './validate'

export interface Subscriptions_TestClockAdvanceRow {
id?: number
days?: number
offset_days_after?: number
advanced_by?: string
created_at?: string
chronology?: Subscriptions_TestClockChronologyRow[]
}

registerContract('Subscriptions_TestClockAdvanceRow', {
  id:                { type: 'number',  required: false },
  days:              { type: 'number',  required: false },
  offset_days_after: { type: 'number',  required: false },
  advanced_by:       { type: 'string',  required: false },
  created_at:        { type: 'string',  required: false },
  chronology: {
    type: 'array',
    required: false,
    items: {
      kind:       { type: 'string',  required: false },
      boundary:   { type: 'string',  required: false },
      event_type: { type: 'string',  required: false },
      event_id:   { type: 'string',  required: false },
      outcome:    { type: 'string',  required: false },
      detail:     { type: 'string',  required: false },
      job_type:   { type: 'string',  required: false },
      run_id:     { type: 'number',  required: false },
      summary:    { type: 'string',  required: false },
    },
  },
})
